module.exports = __webpack_public_path__ + "static/media/matching-education-lateral-nonflexion-up.580a7711.png";